import React from "react";
import {
  capitalizeWords,
  formatPricingPeriod,
  toPascalCase,
} from "rc-app/utils";
import Icon from "../Icons";
// import UserService from "rc-app/services/UserService";

export const PropertyCard = ({
  digitalTwin,
  // isExclusive,
  amount,
  contractType,
  // tours,
  // handleDetailButton,
  isCustomerDetails,
  isDetails,
}: any) => {
  // const extractFirstPTag = (input: any) => {
  //   if (typeof input !== "string") {
  //     return "";
  //   }

  //   // Return plain text immediately if no HTML tags detected
  //   if (!/<[a-z][\s\S]*>/i.test(input)) {
  //     return input.trim();
  //   }

  //   try {
  //     // Create temporary element and parse HTML
  //     const temp = document.createElement("div");
  //     temp.innerHTML = input;

  //     // Extract content from first <p> tag if exists
  //     const firstPTag = temp.querySelector("p");
  //     if (firstPTag) {
  //       return firstPTag.textContent?.trim() || "";
  //     }

  //     // If no <p> tags but HTML exists, return all text content
  //     return temp.textContent?.trim() || "";
  //   } catch (e) {
  //     // Fallback for any DOM parsing errors
  //     return input
  //       .replace(/<[^>]*>/g, " ")
  //       .replace(/\s+/g, " ")
  //       .trim();
  //   }
  // };
  console.log("ptptpt", digitalTwin);
  

  return (
    <>
      <div className="flex items-center lg:justify-between  max-lg:gap-2">
        <span className="font-semibold max-lg:w-full text-lg 2xl:text-xl max-sm:text-base text-[#54B7E4]">
          {digitalTwin && capitalizeWords(digitalTwin?.title)}
        </span>
        <div className="flex justify-end items-center opacity-80 gap-3 2xl:text-xl text-[#008564] dark:text-white text-[12px] max-lg:text-[13px]">
          {digitalTwin?.property_id}
        </div>
      </div>
      {/* {!isDetails && (
        <p className="text-base max-sm:text-sm black dark:text-[#889DB2]">
          {toPascalCase(extractFirstPTag(digitalTwin?.description)).slice(
            0,
            80
          )}
          {toPascalCase(extractFirstPTag(digitalTwin?.description)).slice(0, 80)
            .length > 0 && "..."}
        </p>
      )} */}
      {isDetails && (
        <div className="grid grid-cols-2 gap-2 lg:gap-2 xl:grid-cols-3  items-center">
          <span className="flex-col xl:flex-row-reverse xl:justify-end xl:gap-2  text-[#889DB2] flex   font-medium  max-xl:text-sm text-[16px]">
            <span className="text-black  dark:text-white font-medium flex items-center ">
              {toPascalCase(digitalTwin?.characteristics.type_of_property)}
            </span>
            Property Type
          </span>
          <span className="flex flex-col xl:flex-row-reverse xl:justify-end xl:gap-2  text-black dark:text-white font-medium  max-xl:text-sm text-[16px] ">
            {capitalizeWords(digitalTwin?.agency.name)}
            <span className="flex text-[#889DB2] max-xl:text-sm text-[16px] font-normal">
              Developer
            </span>
          </span>
          <span className="flex flex-col xl:flex-row-reverse xl:justify-end xl:gap-2   text-black dark:text-white font-medium  max-xl:text-sm text-[16px]">
            {toPascalCase(digitalTwin?.characteristics.contract_type)}
            <span className="flex text-[#889DB2]  max-xl:text-sm text-[16px] font-normal ">
              Transaction Type
            </span>
          </span>
          <span className="flex flex-col xl:flex-row-reverse xl:justify-end xl:gap-2  text-black dark:text-white font-medium  max-xl:text-sm text-[16px] ">
            {toPascalCase(digitalTwin?.address.city)}
            <span className="flex text-[#889DB2] max-xl:text-sm text-[16px] font-normal">
              Location
            </span>
          </span>
          <span className="flex flex-col xl:flex-row-reverse xl:justify-end xl:gap-2  text-black dark:text-white font-medium  max-xl:text-sm text-[16px]">
            {digitalTwin.characteristics.area?.value != null
              ? digitalTwin.characteristics.area?.value +
                " " +
                digitalTwin.characteristics.area?.unit
              : 0}
            <span className="flex text-[#889DB2] max-xl:text-sm text-[16px] font-normal">
              Size
            </span>
          </span>
          {amount?.currency != null && (
            <span className="text-[#889DB2] flex flex-col xl:flex-row-reverse xl:justify-end xl:gap-2 items-cente font-medium  max-xl:text-sm text-[16px]">
              <span className="text-black  dark:text-white font-medium flex items-center ">
                {
                  // (contractType === "Sale" || contractType === "Rent") &&
                  amount?.currency["symbol"]
                }
                {(contractType === "Sale" || contractType === "Rent") &&
                  " " + amount.price}
                {contractType === "Rent" &&
                  " " + formatPricingPeriod(amount.fee_frequency)}
                {contractType === "Lease" && " " + 0}
                {contractType === "Showcase" && " " + 0}
                {contractType === "Investment" && " " + 0}
                {contractType === "Other" && " " + 0}
              </span>
              {contractType === "Sale" && "Price Range"}
              {contractType === "Rent" && "Rent"}
              {contractType === "Lease" && "Price Range"}
              {contractType === "Showcase" && "Price Range"}
              {contractType === "Investment" && "Price Range"}
              {contractType === "Other" && "Price Range"}{" "}
            </span>
          )}

          <span className="flex flex-col xl:flex-row-reverse xl:justify-end xl:gap-2  text-black dark:text-white font-medium  max-xl:text-sm text-[16px]">
            {digitalTwin?.energy_efficiency.state_of_construction}
            <span className="flex text-[#889DB2] max-xl:text-sm text-[16px] font-normal">
              Status
            </span>
          </span>
          <span className="col-span-2 xl:col-span-2 text-[#889DB2] flex flex-col xl:flex-row-reverse xl:justify-end xl:gap-2 font-medium max-xl:text-sm text-[16px] min-w-0 flex-1">
            {/* <span className="text-[#889DB2] flex flex-col xl:flex-row-reverse xl:justify-end xl:gap-2  font-medium  max-xl:text-sm text-[16px]"> */}
            <span className="text-black  dark:text-white font-medium flex items-center  ">
              {toPascalCase(digitalTwin?.address.city)} /{" "}
              {toPascalCase(digitalTwin?.address.province)} /{" "}
              {toPascalCase(digitalTwin?.address.country)}
            </span>
            City / State / Country
          </span>

          {/* visible on customer details page */}
          {isCustomerDetails && (
            <span className=" text-black dark:text-[#889DB2] font-bold max-xl:text-sm text-[16px]">
              {digitalTwin?.characteristics.contract_type === "Sale" && "Price"}
              {digitalTwin?.characteristics.contract_type === "Rent" && "Rent"}
              {digitalTwin?.characteristics.contract_type === "Lease" &&
                "Lease"}
              {digitalTwin?.characteristics.contract_type === "Showcase" &&
                "Showcase"}
              {digitalTwin?.characteristics.contract_type === "Investment" &&
                "Investment"}
              {digitalTwin?.characteristics.contract_type === "Others" &&
                "Others"}{" "}
              <span className="text-white  font-bold max-xl:text-sm text-[16px] ml-1">
                {(digitalTwin?.characteristics.contract_type === "Sale" ||
                  digitalTwin?.characteristics.contract_type === "Rent") &&
                  digitalTwin?.pricing?.currency["symbol"]}
                {(digitalTwin?.characteristics.contract_type === "Sale" ||
                  digitalTwin?.characteristics.contract_type === "Rent") &&
                  " " + digitalTwin?.pricing.price}
                {digitalTwin?.characteristics.contract_type === "Rent" &&
                  " " +
                    formatPricingPeriod(digitalTwin?.pricing?.fee_frequency)}
              </span>
            </span>
          )}
        </div>
      )}

      {!isDetails && (
        <div className="flex flex-col gap-2 ">
          <div className="flex w-full items-center gap-2">
            <Icon name="ic-location" className="w-5 h-5 " />
            <span className="text-black  dark:text-white text-sm flex items-center ">
              {`${toPascalCase(digitalTwin?.address.city)}, ${toPascalCase(
                digitalTwin?.address.province
              )}, ${toPascalCase(digitalTwin?.address.country)}`}
            </span>
          </div>

          <div className="flex w-full gap-2">
            <div className="flex items-center w-[50%] gap-2">
              <Icon name="ic-home" className="w-5 h-5 " />
              <span className="text-black  dark:text-white text-sm flex items-center ">
                {toPascalCase(digitalTwin?.characteristics.type_of_property)}
              </span>
            </div>
            <div className="flex items-center w-[50%] gap-2">
              <Icon name="ic-tag" className="w-5 h-5 " />
              <span className="text-black  dark:text-white text-sm flex items-center ">
                {`For ${toPascalCase(
                  digitalTwin?.characteristics.contract_type
                )} `}
              </span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
